import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Page } from "../components/AppShell";
import CrudPanel from "../components/CrudPanel";

export default function Routes() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/users").then(r => setUsers(r.data)); }, []);

  return (
    <Page
      title="Routes"
      subtitle="LEGAL / FIELD ROUTES"
      breadcrumbs={[{ label: "Dashboard", to: "/" }, "Routes"]}
      testid="routes-page"
    >
      <CrudPanel
        endpoint="/routes"
        testid="route"
        columns={[
          { key: "name", label: "NAME" },
          { key: "assigned_user_id", label: "ASSIGNED", render: r => users.find(u => u.id === r.assigned_user_id)?.name || "—" },
          { key: "scheduled_date", label: "DATE", render: r => r.scheduled_date ? new Date(r.scheduled_date).toLocaleDateString() : "—" },
          { key: "total_distance_miles", label: "MILES", numeric: true },
        ]}
        formFields={[
          { key: "name", label: "NAME" },
          { key: "assigned_user_id", label: "ASSIGNED TO", type: "select", options: users.map(u => ({ id: u.id, name: u.name })) },
          { key: "scheduled_date", label: "DATE", type: "date" },
          { key: "total_distance_miles", label: "DISTANCE (MI)", type: "number" },
          { key: "notes", label: "NOTES", type: "textarea" },
        ]}
      />
    </Page>
  );
}
